import { render, staticRenderFns } from "./OpenedCard.vue?vue&type=template&id=4fe96d10&scoped=true&"
import script from "./OpenedCard.vue?vue&type=script&lang=js&"
export * from "./OpenedCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe96d10",
  null
  
)

export default component.exports